import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import ItemService from "../../../services/supplier_appCommonService";
import ItemServiceV1 from "../../../services/human_resource_appCommonService";
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  // getCustomerList,
  workflow,
} from "../../../redux/feature/customer_app/customerSlice";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { formatDate, getContactDetails } from "../../../common/Validations";
import { SearchField } from "../../../Components/formElements/SearchField";
import CreateCustomerMasterModal from "../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../common/Validations";
import ChatBox from "../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import CommonFilterCustomerV2 from "../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";
import HRConstants from "../../../common/HRConstants";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import { getModuleStats } from "../../../redux/feature/warehouse_app/warehouseSlice";
import toast from "react-hot-toast";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import { employeeNr, getClientList } from "../../../redux/feature/hr_app/hrSlice";
import { ChartBarIcon } from "@heroicons/react/24/solid";
const ClientList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Client");
  localStorage.setItem("submenu", "Client");
  let clientData = useSelector((state) => state?.hr?.client); // User Details from Store
  let customerTable = useSelector((state) => state?.hr?.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
   // eslint-disable-next-line 
  const [filteredData, setFilteredData] = useState([]);
  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [getFilter, setFilter] = useState({});
  const DEFAULT_LIST_PARAMS = {
    queryName: "Get_Client_List",
    module: "",
    page: 1,
    per_page: 10,
  };

  //cancle and delete
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const statsPayload = {
    dashboard: "hr_module",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };
  const refreshWarehousePage = () => {
    dispatch(getClientList(DEFAULT_LIST_PARAMS));
    dispatch(getModuleStats(statsPayload));
  };
  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : selectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.statusHeader !== "Cancelled" && item?.statusHeader !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.stockNr)));
  };
  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : selectedRows;

      const payload = {
        documentNumber: rows.map((item) => item.userId),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };

      const res = await ItemServiceV1.cancelOrDeleteEmp(payload);

      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });

        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };
  // Chat Implementation
  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const detailedPage = (customerID) => {
    dispatch(employeeNr(customerID));
    navigate(HRConstants.HR_CLIENT_DETAILS);
  };
  const projectCreation = (customerID) => {
    dispatch(employeeNr(customerID));
    navigate(HRConstants.HR_PROJECT_CREATE);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  // OnClick on Certificate document Data
  const certificateDocumentShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadClientData = async () => {
    setData(clientData?.data);
  };
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "Get_Client_List",
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "Get_Client_List",
        page: page,
        per_page: getNewPerPage,
      };
    }
    dispatch(getClientList(obj));
    // setData(clientData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "Get_Client_List",
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "Get_Client_List",
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getClientList(obj));
    // setData(clientData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_Client_List",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getClientList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadClientData();
      dispatch(workflow({}));
    };

    fetchData();

    // loadClientData(); // fetch page 1 of users
    // dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientData?.data]);
  useEffect(() => {
    if (clientData?.data) {
      setData(clientData.data);
    }
  }, [clientData]);
  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "Get_Client_List",
      page: 1,
      per_page: 10,
    };
    dispatch(getClientList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columns = [
    {
      name: "Clinet Id",
      id: "userId",
      cell: (row) => {
        const docNo = row.userId || row.draftNr;

        return (
          <button className="btnInfo" onClick={() => detailedPage(docNo, row)}>
            {docNo}
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Project",
      id: "userId",
      cell: (row) => {
        return (
          <button
            className="btnInfo"
            onClick={() => projectCreation(row.userId)}
          >
            Project
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Client Name",
      id: "clientName",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold text-primary">
            {/* {row.employeeName} */}
            {row.clientName}
          </span>
        </>
      ),
      selector: (row) => row.clientName,
      sortable: true,
      width: "150px",
    },

    {
      name: "Address",
      selector: (row) => row.address || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.address} </p>
          <p className="m-0 p-0 fw-bold">{row.address2} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.headerStatus,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.headerStatus} />
        </>
      ),
      width: "170px",
    },
    {
      name: "Documents",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => certificateDocumentShowModal(row.certifications)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">{row.certifications?.length}</span>
        </>
      ),
      width: "130px",
    },
    {
      name: "Contact Person",
      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactName}</span>
        </>
      ),
      // selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number",
      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactNumber}</span>
        </>
      ),
      // selector: (row) => row.contactNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Email",
      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactEmail}</span>
        </>
      ),
      // selector: (row) => row.email,
      sortable: true,
      width: "220px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;

        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";

        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(row.userId))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
              },
              {
                key: "doc",
                label: "Documents",
                icon: "bi bi-file-earmark",
                onClick: () => projectCreation(row.userId),
                disabled: isDeleted,
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => detailedPage(row.userId),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "Cancel"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];

  const certificateDocumentColInfo = [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Issuing  Date",
      cell: (row) => <span>{formatDate(row.issueDate)} </span>,
      width: "180px",
    },
    {
      name: "Certificate Attachment",
      cell: (row) => (
        <div className="d-flex justify-content-center">
          {row.iSOCertification ? (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.iSOCertification)}
            />
          ) : (
            "--"
          )}
        </div>
      ),
      width: "180px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handleEmployeeRegister = () => {
    navigate(HRConstants.HR_CLIENT_CREATE);
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "Get_Client_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getClientList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Client List</h2>
                <p className="subText">Client Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="client"
                  keyName="headerStatus"
                  paginatedList={clientData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Client List</span>
                      <span className="subHeaderTitle">
                        View of Client and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={handleEmployeeRegister}
                        >
                          <i class="bi bi-person-plus"></i> Add Client
                        </button>
                      </Col>
                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i class="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn columnIndexes={[2]} leftOffsets={[0, 40]} />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={clientData?.status}
                          paginationRowsPerPageOptions={Constants?.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable?.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                          onSelectedRowsChange={handleRowSelected}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
      <CancelModal
        title={
          actionType === "Delete" ? "Delete the Stock" : "Cancel the Stock"
        }
        type="Client"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="userId"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
    </main>
  );
};

export default ClientList;
